import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_mens_accessories: FaireCategoryEntity = {
  token: "catalog_cat_mens-accessories",
  type: "category",
  name: "Men's accessories",
  count: 17,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
